import clsx from "clsx";
import React from "react";

import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";

import { DASH } from "common/constants";
import Loader from "components/Loader";
import { useRacehorse360Api } from "hooks/api";
import { getHorseDetails, SELECTED_HORSE_OPTIONS } from "./helper";
import useStyles from "./styles";

interface IProps {
  horseId: string;
  horseName: string;
  registrationNumber: string;
  raceReady: string;
  onClose: (value: boolean) => void;
}

const HorseDetailsModal = (props: IProps) => {
  const {
    horseId,
    horseName,
    registrationNumber,
    raceReady = DASH,
    onClose
  } = props;

  const classes = useStyles();
  const { useGetHorse } = useRacehorse360Api();

  const { isLoading: isHorseLoading, data: horse } = useGetHorse(
    {
      id: horseId,
      getOptions: { select: SELECTED_HORSE_OPTIONS }
    },
    {
      enabled: Boolean(horseId)
    }
  );

  const handleCloseModal = () => {
    onClose(false);
  };

  const renderDetail = (currentDetail, horseDetails) => {
    const isMultipleValue = Array.isArray(horseDetails[currentDetail]);
    let value = horseDetails[currentDetail];

    if (isMultipleValue) {
      value = horseDetails[currentDetail].map(detail => (
        <div key={detail} className={classes.multipleValue}>
          {detail}
        </div>
      ));
    }

    return (
      <div key={currentDetail} className={classes.row}>
        <div className={clsx(classes.cell, { multiple: isMultipleValue })}>
          {currentDetail}
        </div>
        <div className={clsx(classes.cell, { multiple: isMultipleValue })}>
          {value}
        </div>
      </div>
    );
  };

  const renderContent = () => {
    if (isHorseLoading) return <Loader />;

    const horseDetails = getHorseDetails(horse, raceReady);

    return (
      <>
        <div className={classes.horseName}>{horseName}</div>
        <div className={classes.horseDetails}>
          {Object.keys(horseDetails).map(detail =>
            renderDetail(detail, horseDetails)
          )}
        </div>
      </>
    );
  };

  return (
    <Dialog open={true} onClose={null} classes={{ paper: classes.root }}>
      <DialogTitle
        disableTypography={true}
        classes={{
          root: classes.dialogTitle
        }}
      >
        <span>Horse Details</span>
        <IconButton
          aria-label="close"
          className={classes.xButton}
          onClick={handleCloseModal}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent classes={{ root: classes.dialogContent }}>
        {renderContent()}
      </DialogContent>

      <DialogActions classes={{ root: classes.dialogActions }}>
        <Button aria-label="close-button" onClick={handleCloseModal}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default HorseDetailsModal;
